var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSync(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "sync",
    d: "M0.666656 11.3333V10H2.49999L2.23332 9.76667C1.68888 9.22222 1.29166 8.63056 1.04166 7.99167C0.791656 7.35278 0.666656 6.7 0.666656 6.03333C0.666656 4.8 1.0361 3.70278 1.77499 2.74167C2.51388 1.78056 3.47777 1.14444 4.66666 0.833333V2.23333C3.86666 2.52222 3.22221 3.01389 2.73332 3.70833C2.24443 4.40278 1.99999 5.17778 1.99999 6.03333C1.99999 6.53333 2.09443 7.01944 2.28332 7.49167C2.47221 7.96389 2.76666 8.4 3.16666 8.8L3.33332 8.96667V7.33333H4.66666V11.3333H0.666656ZM7.33332 11.1667V9.76667C8.13332 9.47778 8.77777 8.98611 9.26666 8.29167C9.75555 7.59722 9.99999 6.82222 9.99999 5.96667C9.99999 5.46667 9.90554 4.98056 9.71666 4.50833C9.52777 4.03611 9.23332 3.6 8.83332 3.2L8.66666 3.03333V4.66667H7.33332V0.666667H11.3333V2H9.49999L9.76666 2.23333C10.3111 2.77778 10.7083 3.36944 10.9583 4.00833C11.2083 4.64722 11.3333 5.3 11.3333 5.96667C11.3333 7.2 10.9639 8.29722 10.225 9.25833C9.4861 10.2194 8.52221 10.8556 7.33332 11.1667Z",
    fill: "#076ABC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSync);
export default __webpack_public_path__ + "static/media/sync.010546956232c39f3c117998340f82e7.svg";
export { ForwardRef as ReactComponent };